import React from "react";
import { GraduationCap, Award, Code2 } from "lucide-react";
import { Card } from "./ui/card";
import { personalInfo, education } from "../mock";

const About = () => {
  return (
    <section id="about" className="min-h-screen bg-[#0a0a0a] py-32 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left: Text Content */}
          <div className="space-y-8">
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 drop-shadow-[0_0_20px_rgba(59,130,246,0.3)]">
              About Me
            </h2>
            <p className="text-xl md:text-2xl text-gray-300 leading-relaxed">
              M.Tech student passionate about{" "}
              <span className="text-blue-400 font-semibold drop-shadow-[0_0_10px_rgba(59,130,246,0.5)]">
                Deep Learning
              </span>
              ,{" "}
              <span className="text-cyan-400 font-semibold drop-shadow-[0_0_10px_rgba(6,182,212,0.5)]">
                GANs
              </span>
              , and{" "}
              <span className="text-blue-300 font-semibold drop-shadow-[0_0_10px_rgba(147,197,253,0.5)]">
                Cybersecurity
              </span>
              .
            </p>
            <p className="text-lg text-gray-400 leading-relaxed">
              I build intelligent systems that solve real problems. My work
              focuses on the intersection of artificial intelligence and
              security, creating models that not only learn but adapt to
              emerging threats.
            </p>
            <p className="text-lg text-gray-400 leading-relaxed">
              Currently pursuing my Master's at M. S. Ramaiah Institute of
              Technology, I'm exploring cutting-edge applications of generative
              adversarial networks in intrusion detection systems.
            </p>
          </div>

          {/* Right: Stats Cards */}
          <div className="space-y-6">
            <Card className="bg-gradient-to-br from-blue-600/20 to-cyan-600/20 border-blue-500/30 p-8 backdrop-blur-sm hover:scale-105 transition-transform duration-300 shadow-[0_0_30px_rgba(59,130,246,0.2)] hover:shadow-[0_0_40px_rgba(59,130,246,0.3)]">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-blue-500/20 rounded-lg shadow-[0_0_15px_rgba(59,130,246,0.3)]">
                  <GraduationCap className="w-8 h-8 text-blue-400" />
                </div>
                <div>
                  <div className="text-5xl font-bold text-white mb-2 drop-shadow-[0_0_10px_rgba(59,130,246,0.4)]">
                    8.22
                  </div>
                  <div className="text-gray-300 text-lg">CGPA</div>
                  <div className="text-gray-400 text-sm mt-1">
                    M.Tech, Computer Networks
                  </div>
                </div>
              </div>
            </Card>

            <Card className="bg-gradient-to-br from-cyan-600/20 to-blue-600/20 border-cyan-500/30 p-8 backdrop-blur-sm hover:scale-105 transition-transform duration-300 shadow-[0_0_30px_rgba(6,182,212,0.2)] hover:shadow-[0_0_40px_rgba(6,182,212,0.3)]">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-cyan-500/20 rounded-lg shadow-[0_0_15px_rgba(6,182,212,0.3)]">
                  <Code2 className="w-8 h-8 text-cyan-400" />
                </div>
                <div>
                  <div className="text-5xl font-bold text-white mb-2 drop-shadow-[0_0_10px_rgba(6,182,212,0.4)]">
                    3+
                  </div>
                  <div className="text-gray-300 text-lg">Major Projects</div>
                  <div className="text-gray-400 text-sm mt-1">
                    AI/ML & Cybersecurity
                  </div>
                </div>
              </div>
            </Card>

            <Card className="bg-gradient-to-br from-blue-500/20 to-cyan-500/20 border-blue-400/30 p-8 backdrop-blur-sm hover:scale-105 transition-transform duration-300 shadow-[0_0_30px_rgba(59,130,246,0.2)] hover:shadow-[0_0_40px_rgba(59,130,246,0.3)]">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-blue-400/20 rounded-lg shadow-[0_0_15px_rgba(96,165,250,0.3)]">
                  <Award className="w-8 h-8 text-blue-300" />
                </div>
                <div>
                  <div className="text-4xl font-bold text-white mb-2 drop-shadow-[0_0_10px_rgba(96,165,250,0.4)]">
                    Full-Stack
                  </div>
                  <div className="text-gray-300 text-lg">Developer</div>
                  <div className="text-gray-400 text-sm mt-1">
                    MERN Stack • Django
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
